import { jsx, jsxs } from 'react/jsx-runtime';
import { forwardRef, useState, useCallback, useEffect } from 'react';
import { Field, Label, Switch } from '@headlessui/react';
import classNames from 'classnames';
import { ToggleProvider } from './Toggle.Context/Toggle.Context.es.js';
import { ToggleDescription } from './Toggle.Description/Toggle.Description.es.js';

const Toggle = /*#__PURE__*/ forwardRef(({ disabled, selected: selectedProp, label, onChange, size = 'base', children, ...rest }, ref)=>{
    const [selected, setSelected] = useState(!!selectedProp);
    const handleChange = useCallback((selected)=>{
        setSelected(selected);
        onChange?.(selected);
    }, [
        onChange
    ]);
    useEffect(()=>{
        setSelected(!!selectedProp);
    }, [
        selectedProp
    ]);
    return jsx(ToggleProvider, {
        disabled: disabled,
        children: jsxs(Field, {
            as: "div",
            className: "cb-toggle",
            ...rest,
            children: [
                label && jsx(Label, {
                    className: classNames('label', {
                        disabled
                    }),
                    children: label
                }),
                jsxs("div", {
                    className: "toggle-switch-description-container",
                    children: [
                        children,
                        jsx(Switch, {
                            ...rest,
                            ref: ref,
                            checked: selected,
                            className: classNames('toggle-switch', size, {
                                selected,
                                disabled
                            }),
                            disabled: disabled,
                            onChange: handleChange,
                            children: jsx("span", {
                                "aria-hidden": "true",
                                className: "toggle-switch-circle"
                            })
                        })
                    ]
                })
            ]
        })
    });
});
const ToggleNamespace = Toggle;
Toggle.displayName = 'Toggle';
ToggleNamespace.Description = ToggleDescription;

export { ToggleNamespace as Toggle, ToggleNamespace, ToggleNamespace as default };
//# sourceMappingURL=Toggle.es.js.map
